import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import HomeLayout from "../components/Layout/HomeLayout";
import OtherLayout from "../components/Layout/OtherLayout";
import { ROUTES } from "../constants/appConstants";

const About = lazy(() => import("../pages/About/About"));
const Careers = lazy(() => import("../pages/Careers/Careers"));
const Contact = lazy(() => import("../pages/Contact/Contact"));
const PolicySubpage = lazy(
  () => import("../pages/PolicySubpage/PolicySubpage")
);
const Home = lazy(() => import("../pages/Home/Home"));
const Policies = lazy(() => import("../pages/Policies/Policies"));
const TermsConditions = lazy(
  () => import("../pages/TermsConditions/TermsConditions")
);
const NotFoundPage = lazy(() =>
  import("../pages/404/NotFoundPage").then((module) => ({
    default: module.NotFoundPage,
  }))
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<div></div>}>
      <Routes>
        {/* Routes using HomeLayout */}
        <Route element={<HomeLayout />}>
          <Route path={ROUTES.HOME.path} element={<Home />} />
        </Route>

        {/* Routes using OtherLayout */}
        <Route element={<OtherLayout />}>
          <Route path={ROUTES.ABOUT.path} element={<About />} />
          <Route path={ROUTES.CAREER.path} element={<Careers />} />
          <Route path={ROUTES.CONTACT.path} element={<Contact />} />
          <Route
            path={ROUTES.TERMS_CONDITIONS.path}
            element={<TermsConditions />}
          />
          <Route
            path={ROUTES.POLICY_SUBPAGE.path}
            element={<PolicySubpage />}
          />
          <Route path={ROUTES.POLICIES.path} element={<Policies />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
